import Api from "./api";

export const getEnableTagsOnArticles = async (id) => {
  let data = [];
  await Api.get("/configarticles/enable-tags-on-articles")
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};
